import { useMemo } from "react";
import { Dispatch, AnyAction } from "redux";
import { useDispatch, useSelector } from "react-redux";

import { ApplicationState } from "../../store/RootReducers";
import { eligibilityActions } from "../../store/eligibility/actions";
import { DropdownOptions } from "../../store/eligibility/state";

interface Selectors {
  industriesData: DropdownOptions;
}
interface ActionDispatchers {
  getIndustries: () => void;
}

const useIndustries = (): Selectors & ActionDispatchers => {
  const dispatch = useDispatch<Dispatch<AnyAction>>();
  const selectors = useSelector(stateSelector);
  const actionDispatchers = useMemo(() => actions(dispatch), [dispatch]);

  return { ...selectors, ...actionDispatchers };
};

const stateSelector = (state: ApplicationState): Selectors => ({
  industriesData: state.eligibilityState.industries
});

const actions = (dispatch: Dispatch<AnyAction>): ActionDispatchers => ({
  getIndustries: () => dispatch(eligibilityActions.getIndustries.started())
});

export default useIndustries;
